require( './bootstrap' );

window.currentUrl = location.origin + location.pathname;
feather.replace();

(function () {

	// 네비게이션 active
	$( '#mainNav' ).find( 'a[href="' + currentUrl + '"]' ).parents( '.nav-item' ).addClass( 'active' );
	$( '#mainNav' ).find( 'a[href="' + currentUrl + '"].dropdown-item' ).addClass( 'active' );
	$( '#adminSideMenu' ).find( 'a[href="' + currentUrl + '"]' ).parents( '.submenu.collapse' ).collapse( 'show' );
	$( '#top-bar .nav-link' ).click( function ( e ) {
		e.preventDefault();
	} );

	$( '.sidemenu a.nav-link[href="' + currentUrl + '"]' ).addClass( 'active' );

	let sidemenu_links = document.querySelectorAll( '.sidemenu .nav-link' );
	if ( sidemenu_links.length > 0 ) {
		sidemenu_links.forEach( function ( el ) {
			let regHan = /[가-핳]+/gi;
			let reg = /[\(,a-z,A-Z,\s,\),\&]+$/gi;
			let isMatched = el.innerText.match( reg );
			if ( isMatched && null !== el.innerText.match( regHan ) ) {
				el.innerHTML = el.innerText.replace( isMatched[ 0 ], '<br>' + isMatched[ 0 ] );
			}
		} );
	}

	$( window ).scroll( function () {
		$( this ).scrollTop() >= 100
			? $( '#main-navigation' ).css( 'background-color', '#2D7A69' )
			: $( '#main-navigation' ).css( 'background-color', 'rgb(21, 92, 74)' );
	} );

	lightbox.option( {
		                 'resizeDuration': 200,
		                 'wrapAround': true,
		                 'fadeDuration': 200
	                 } );

	$( '#flash-overlay-modal' ).modal();
	$( '[data-toggle="tooltip"]' ).tooltip();
	$( 'div.alert' ).not( '.alert-important' ).delay( 3000 ).fadeOut( 350 );

	// AnimateCss 함수 확장
	$.fn.extend( {
		             animateCss: function ( animationName, callback ) {
			             var animationEnd = (function ( el ) {
				             var animations = {
					             animation: 'animationend',
					             OAnimation: 'oAnimationEnd',
					             MozAnimation: 'mozAnimationEnd',
					             WebkitAnimation: 'webkitAnimationEnd',
				             };

				             for ( var t in animations ) {
					             if ( el.style[ t ] !== undefined ) {
						             return animations[ t ];
					             }
				             }
			             })( document.createElement( 'div' ) );

			             this.addClass( 'animated ' + animationName ).one( animationEnd, function () {
				             $( this ).removeClass( 'animated ' + animationName );

				             if ( typeof callback === 'function' ) callback();
			             } );

			             return this;
		             },
	             } );

	window.authRequestSend = obj => {
		let email = document.querySelector( '#email' );

		if ( email.value.length === 0 ) {
			alert( '가입 시 등록하신 이메일 주소를 입력하세요.' );
			email.classList.add( 'is-invalid' );
			email.focus();
			return false;
		}

		axios.post( obj.dataset.action, { email: email.value } )
		     .then( ( r ) => {
			     alert( r.data.message );
		     } )
		     .catch( ( err ) => {
			     console.error( err.response ? err.response : err.request );

			     let msg;

			     switch ( err.status ) {
				     case '404' :
					     msg = err.response.data.message;
				     case '403' :
					     msg = err.response.data.message;
				     case '409' :
					     msg = err.response.data.message;
					     break;
				     default :
					     msg = err.response ? err.response.data.message : err.request.message;
			     }

			     alert( msg );

		     } )
	};


	// 미디어 라이브러리 컨트롤
	window.loadLibrary = function ( page_url ) {

		const target = $( '#media-items .row' );

		if ( target.find( '.card-img-top' ).length > 0 ) {
			target.empty().html( '<div class="col"><img src="/images/loading50.gif" alt="loading..." class="d-flex mx-auto my-5"></div>' );
		}

		if ( page_url === undefined ) {
			page_url = '/admin/media-library?page=1';
		}

		axios.get( page_url )
		     .then( function ( response ) {
			     console.log( response );
			     if ( response.status === 200 ) {
				     const {
					     data: {
						     data: items,
						     current_page,
						     first_page_url,
						     from,
						     last_page,
						     last_page_url,
						     links,
						     next_page_url,
						     prev_page_url,
						     path,
						     per_page,
						     to,
						     total
					     }
				     } = response;
				     const code = [];

				     $.each( items, function () {
					     const filename = this.filename;
					     const mimetype = this.mimetype;
					     const size = this.size;
					     const path = this.path;
					     const url = `/storage/${this.path}`;
					     const created_at = this.created_at;
					     let tag = '<div class="col">';

					     tag += `<div class="card mb-2">`;

					     if ( mimetype.split( '/' )[ 0 ] == 'image' ) {
						     tag += `<img src="${url}" class="card-img-top img-fluid d-block mx-auto" alt="${filename}">`;
					     }

					     tag += `<div class="card-body">
                              <p class="filename">`;

					     if ( mimetype.split( '/' )[ 0 ] != 'image' ) {
						     tag += `<i data-feather="file"></i><br>${filename}`;
					     }

					     tag += `(${FileSize( size, true )})</p>
							        <a href="javascript:;" class="card-link addMedia" data-id="${this.id}" data-url="${url}" data-path="${path}" data-mimetype="${mimetype.split( '/' )[ 0 ]}" data-filename="${filename}">본문 추가</a>
							        <a href="javascript:;" class="card-link addFeaturedImage" data-id="${this.id}" data-url="${url}" data-path="${path}" data-mimetype="${mimetype.split( '/' )[ 0 ]}" data-filename="${filename}">대표이미지 설정</a>
							        </div>
							        </div>`;

					     tag += `</a></div>`;

					     code.push( tag );
				     } );

				     let paginate = '<div class="col-sm-12 p-3 text-center">';
				     if ( null !== prev_page_url ) {
					     paginate += '<a href="javascript:;" class="btn btn-sm btn-secondary" onclick="loadLibrary(\'' + prev_page_url + '\')">이전</a>';
				     }
				     if ( null !== next_page_url ) {
					     paginate += '<a href="javascript:;" class="btn btn-sm btn-secondary" onclick="loadLibrary(\'' + next_page_url + '\')">다음</a>';
				     }

				     paginate += '</div>';

				     target.empty().append( code.join( '' ) + paginate );

				     feather.replace();
			     }
		     } )
		     .catch( function ( error ) {
			     alert( '오류 발생' );
			     console.log( error );
		     } );
	};

	// 미디어 라이브러리 : 미디어 본문에 추가
	$( document ).on( 'mousedown', '.addMedia', function ( e ) {
		e.preventDefault();
		const parent = $( '#mediaLibWindow' );
		const url = $( this ).data( 'url' );
		const path = $( this ).data( 'path' );
		const filename = $( this ).data( 'filename' );
		const mimetype = $( this ).data( 'mimetype' );
		const code = [];

		if ( mimetype === 'image' ) {
			code.push( '<img src="' + url + '" class="img-fluid d-block my-1 mx-auto">' );
		}
		else {
			code.push( '<a href="' + url + '"><i data-feather="file"></i> ' + filename + '</a>' );
		}

		tinyMCE.execCommand( 'mceInsertContent', false, code.join( '' ) );
		parent.fadeOut();
	} );

	// 미디어 라이브러리 : Featured Image에 추가
	$( document ).on( 'mousedown', '.addFeaturedImage', function () {
		const parent = $( '#mediaLibWindow' );
		const url = $( this ).data( 'url' );
		const path = $( this ).data( 'path' );
		const target = $( '#featuredImage' );
		target.val( path );
		$( '#featuredPreview' ).empty().append( '<img src="' + url + '" class="img-fluid d-block mx-auto my-1">' );
		parent.fadeOut();
	} );

	// 업로드 트리거
	$( '#uploadTrigger, #featuredImageUploadTrigger' ).click( function () {
		$( '#fileuploadzone' ).fadeIn();
	} );

	// 미디어 라이브러리 트리거
	$( 'button[data-action="media-library-trigger"]' ).click( function () {
		let target = $( '#mediaLibWindow' );
		loadLibrary();
		if ( target.css( 'display' ) === 'none' ) {
			target.css( 'display', '' );
		}
		else {
			target.css( 'display', 'none' );
		}
	} );

	// 미디어 라이브러리 닫기 버튼
	$( '#closeMediaLibrary' ).click( function () {
		$( '#mediaLibWindow' ).fadeOut();
	} );

	$( '#checkall' ).click( function () {
		if ( $( this ).is( ':checked' ) ) {
			$( 'table input[type="checkbox"]' ).prop( 'checked', true );
		}
		else {
			$( 'table input[type="checkbox"]' ).prop( 'checked', false );
		}
	} );

	$( 'aside .nav-link' ).each( function () {
		if ( $( this ).attr( 'href' ) == currentUrl ) {
			$( this ).addClass( 'active' );
		}
	} );

	var tinymceSetup = function ( ed ) {
		ed.on( 'init', function () {
			this.getDoc().body.style.fontSize = '16px';
			this.getDoc().body.style.fontFamily = 'Gothic A1';
			this.getDoc().body.style.padding = '10px';
			this.getDoc().body.style.boxShadow = '0';
			this.getDoc().body.style.backgroundColor = "white";
		} );
	};

	const tinymceConfig = {
		setup: tinymceSetup,
		relative_urls: false,
		selector: 'textarea#content',
		theme: "modern",
		content_css: '/css/app.css',
		language: 'ko_KR',
		menubar: false,
		statusbar: true,
		resize: true,
		height: 500,
		allow_script_urls: true,
		allow_html_in_named_anchor: true,
		entity_encoding: "raw",
		extended_valid_elements: "script[src|type|language]",
		plugins: 'advlist code media link lists colorpicker paste table textcolor print emoticons preview',
		toolbar: [ 'styleselect forecolor backcolor indent outdent bold italic blockquote removeformat alignleft alignjustify aligncenter alignright bullist numlist media link table code' ],
		skin: 'lightgray',
		body_class: 'entry_content',
		branding: false
	};

	tinymce.init( tinymceConfig );

	$( '#closeUploadzone' ).click( function () {
		$( '#fileuploadzone' ).fadeOut();
	} );


	// Dropzone setting
	var previewNode = document.querySelector( "#template" );
	if ( null !== previewNode ) {
		previewNode.id = "";
		var previewTemplate = previewNode.parentNode.innerHTML;
		previewNode.parentNode.removeChild( previewNode );

		var myDropzone = new Dropzone( document.body, { // Make the whole body a dropzon
			url: '/admin/uploads/store', // Set the url
			paramName: "attachedImage",
			params: {
				_token: csrfToken.content
			},
			acceptedFiles: 'image/*,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.hwp,.txt,.zip,.mp4,.avi, .mp3,.ogg',
			thumbnailMethod: "contain",
			thumbnailWidth: 200,
			thumbnailHeight: 150,
			parallelUploads: 20,
			previewTemplate: previewTemplate,
			autoQueue: true,
			previewsContainer: "#previews",
			clickable: ".uploadTrigger"
		} );

		myDropzone.on( "success", function ( file, responseText ) {
			const self = $( file.previewElement );
			const mediaWindow = $( '#mediaLibWindow' );
			const medialibrary = $( '#mediaLibrarySection' );
			const res = responseText;

			self.find( '.progress' ).css( 'display', 'none' );
			self.find( 'button.delete' ).data( 'file-id', res.id );
			self.find( 'button.append' ).data( {
				                                   'file-id': res.id,
				                                   'file-url': res.path,
				                                   'file-mime': res.mimetype,
				                                   'file-name': res.filename
			                                   } );
			self.find( 'button.appendFeatured' ).data( {
				                                           'file-id': res.id,
				                                           'file-url': res.path,
				                                           'file-mime': res.mimetype,
				                                           'file-name': res.filename
			                                           } );


			let media_tpl = '<div class="col-sm-3">' +
			                '<div class="card mb-2">' +
			                '<img src="/storage/' + res.path + '" class="card-img-top img-fluid d-block mx-auto" alt="' + res.filename + '">' +
			                '<div class="card-body">' +
			                '<p class="filename">' + res.filename + '</p>' +
			                '<a href="javascript:;" class="card-link addMedia" data-id="' + res.id + '" data-path="/storage/' + res.path + '" data-mimetype="' + res.mimetype + '" data-filename="' + res.filename + '">본문 추가</a>' +
			                '<a href="javascript:;" class="card-link addFeaturedImage" data-id="' + res.id + '" data-path="/storage/' + res.path + '" data-mimetype="' + res.mimetype + '" data-filename="res.filename">대표이미지 설정</a>' +
			                '</div>' +
			                '</div>' +
			                '</div>';

			let style = isImage( res.mimetype ) ? 'background-image:url(/storage/' + res.path + ')' : '';


			let tpl2 = '<div class="col-sm-3" id="file-' + res.id + '">' +
			           '<figure>' +
			           '<div class="img-box mb-1 border d-flex flex-row justify-content-center align-items-center" style="' + style + '">';
			if ( isImage( res.mimetype ) ) {
				tpl2 += '<a href="/storage/' + res.path + '" data-lightbox="lightbox" data-title="' + res.filename + '">' +
				        '<img src="/images/blank_img.gif" alt="' + res.filename + '" class="fakeimg">' +
				        '</a>';
			}
			else {
				tpl2 += '<i data-feather="file" style="width:48px;height:48px;"></i>';
			}
			tpl2 += '<button class="btn btn-sm btn-danger media-delete-button" data-file-id="' + res.id + '" type="button">' +
			        '<i data-feather="x"></i>' +
			        '</button>' +
			        '<button data-clipboard-text="/storage/' + res.path + '" class="btn btn-light btn-sm btn-copy" type="button">Copy</button>' +
			        '</div>' +
			        '<figcaption class="figure-caption">' +
			        '<p class="text-truncate" title="' + res.filename + '">' +
			        '<a href="/download/' + res.id + '">' + res.filename + '</a>' +
			        '</p>' +
			        '</figcaption>' +
			        '</figure>' +
			        '</div>';

			if ( mediaWindow.length > 0 ) {
				mediaWindow.find( '#media-items .row' ).prepend( media_tpl );
			}

			if ( medialibrary.length > 0 ) {
				medialibrary.prepend( tpl2 );
				feather.replace();
			}

			self.remove();
		} );

		myDropzone.on( 'queuecomplete', function () {
			$( '#fileuploadzone' ).hide();
			$( 'button[data-action="media-library-trigger"]' ).trigger( 'click' );
		} );

		myDropzone.on( 'error', function ( file, error ) {
			console.log( error, file );
			alert( '업로드 오류' );
		} );
	}

	function isImage( mimetype ) {
		const type = mimetype.split( "/" );
		if ( type[ 0 ] == 'image' ) {
			return true;
		}

		return false;
	}

	function deleteFile( parent, id ) {
		var data = { _token: csrfToken, _method: 'delete' };

		axios.post( '/admin/uploads/destroy/' + id, data )
		     .then( function ( response ) {

			     if ( response.status === 200 ) {
				     $( parent ).remove();
			     }
			     if ( response.status === 404 ) {
				     alert( '파일 삭제 오류' );
				     return false;
			     }
		     } )
		     .catch( function ( error ) {
			     alert( '통신오류!' );
			     console.log( error.response.data );
			     return false;
		     } );
	}

	$( document ).on( 'click', 'button.delete', function ( e ) {
		e.preventDefault();
		var id = $( this ).data( 'file-id' ),
			parent = $( this ).parents( '.file-row' )[ 0 ];
		deleteFile( parent, id );
	} );

	$( document ).on( 'click', 'button.append', function ( e ) {
		e.preventDefault();

		const id = $( this ).data( 'file-id' );
		const url = $( this ).data( 'file-url' );
		const mimeType = $( this ).data( 'file-mime' );
		const filename = $( this ).data( 'file-name' );
		let code = '';

		if ( mimeType.split( '/' )[ 0 ] == 'image' ) {
			code = '<div class="text-center"><img src="' + decodeURIComponent( '/storage/' + url ) + '" class="img-fluid center-block" alt="' + filename + '"></div>';
		}
		else {
			code = '<a href="/file/download/' + url + '">' + filename + '</a>';
		}
		tinyMCE.execCommand( 'mceInsertContent', false, code );
	} );

	$( document ).on( 'click', 'button.appendFeatured', function ( e ) {
		e.preventDefault();
		var id = $( this ).data( 'file-id' ),
			url = '/storage/' + $( this ).data( 'file-url' ),
			mimeType = $( this ).data( 'file-mime' ),
			filename = $( this ).data( 'file-name' );

		if ( $( '#featuredImage' ).length === 1 ) {
			if ( mimeType.split( '/' )[ 0 ] != 'image' ) {
				alert( '이미지를 선택하세요.' );
				return false;
			}
			$( '#featuredImage' ).val( url );
			$( '#featuredPreview' ).empty().append( '<a href="' + url + '" data-lightbox="lightbox">' +
			                                        '<img src="' + url + '" class="img-fluid center-block">' +
			                                        '</a>' );
		}
	} );


	$( document ).on( 'focusin', function ( e ) {
		if ( $( e.target ).closest( ".mce-window" ).length ) {
			e.stopImmediatePropagation();
		}
		if ( $( e.target ).closest( ".moxman-window" ).length ) {
			e.stopImmediatePropagation();
		}
	} );

	window.makeSlug = function ( string ) {
		var regExp = /[\s\{\}\[\]\/?.,;:|\)*~`!^\_+<>@\#$%&\\\=\(\'\"]/gi,
			result = string.replace( regExp, "-" ),
			regExp2 = /\-$/gi,
			final = result.replace( regExp2, '' );

		return final.toLowerCase();
	};
	const datetimepickerConfig = {
		locale: 'ko',
		dayViewHeaderFormat: 'YYYY년 MM월',
		format: 'YYYY-MM-DD HH:mm:ss',
		sideBySide: true,
		icons: {
			time: 'fa fa-clock-o',
			date: 'fa fa-calendar',
			up: 'fa fa-chevron-up',
			down: 'fa fa-chevron-down',
			previous: 'fa fa-chevron-left',
			next: 'fa fa-chevron-right',
			today: 'fa fa-calendar-o',
			clear: 'fa fa-trash',
			close: 'fa fa-times'
		}
	};

	const datetimepickerConfig2 = {
		locale: 'ko',
		dayViewHeaderFormat: 'YYYY년 MM월',
		format: 'YYYY-MM-DD',
		icons: {
			time: 'fa fa-clock-o',
			date: 'fa fa-calendar',
			up: 'fa fa-chevron-up',
			down: 'fa fa-chevron-down',
			previous: 'fa fa-chevron-left',
			next: 'fa fa-chevron-right',
			today: 'fa fa-calendar-o',
			clear: 'fa fa-trash',
			close: 'fa fa-times'
		}
	};

	const dtConfig3 = {
		locale: 'en',
		dayViewHeaderFormat: 'YYYY년 MM월',
		format: 'ddd DD/MM/YYYY'
	};


	$( '.datepicker' ).datetimepicker( dtConfig3 );
	$( '.datetimepicker' ).datetimepicker( datetimepickerConfig );
	$( '.datetimepicker-dateonly' ).datetimepicker( datetimepickerConfig2 );

	window.FileSize = function ( bytes, si ) {
		var thresh = si ? 1000 : 1024;
		if ( Math.abs( bytes ) < thresh ) {
			return bytes + ' B';
		}
		var units = si
			? [ 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ]
			: [ 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB' ];
		var u = -1;
		do {
			bytes /= thresh;
			++u;
		} while ( Math.abs( bytes ) >= thresh && u < units.length - 1 );
		return bytes.toFixed( 1 ) + ' ' + units[ u ];
	};

	window.beforeSubmitWarning = function ( obj ) {
		if ( !confirm( '이 글을 삭제할까요?' ) ) return false;
		obj.submit();
	};

	window.replaceClass = function ( obj, classFrom, classTo ) {
		var t = $( obj );
		if ( t.hasClass( classFrom ) ) {
			t.removeClass( classFrom ).addClass( classTo );
		}
	};

	window.nl2br = ( str ) => {
		let string = removeNl( str );
		string = string.replace( '/\s/gi', '' );
		string = stripTag( string );
		string = string.replace( /\n/gi, "<br>" );

		return string;
	};

	window.stripTag = ( str ) => {
		return str.replace( /(<([^>]+)>)/ig, "" );
	};

	window.removeNl = ( str ) => {
		return str.replace( /\s\n/gi, "" );
	};

	window.showDateKr = ( str ) => {

		const dt = new Date( str );

		/*return dt.getFullYear() + '년'  +
		 (dt.getMonth() + 1) + '월 ' +
		 dt.getDate() + '일 ' +
		 dt.getHours() + '시 ' +
		 dt.getMinutes() + '분';*/

		return dt.toLocaleString();
	};

	window.makeFBtag = ( response ) => {
		const d = response.data;
		const code = [];
		const tg = $( '#facebook-feed .feed' );


		$.each( d, function () {
			if ( this.message && this.type !== 'event' ) {
				const now = showDateKr( this.created_time );
				const message = this.message.length > 300 ? this.message.substring( 0, 300 ) + '...' : this.message;
				let html = '<div class="row">' +
				           '<div class="col-12 col-lg-4">' +
				           '<div style="max-height:200px;overflow-y:hidden;" class="rounded">' +
				           '<a href="https://facebook.com/' + this.id + '" target="_blank">' +
				           '<img src="' + this.full_picture + '" class="img-fluid">' +
				           '</a>' +
				           '</div>' +
				           '</div>' +
				           '<div class="col-12 col-lg-8">' +
				           '<p class="text-primary"><b>' + now + '</b></p>' +
				           '<p><a href="' + this.id + '" target="_blank">' + message + '</a></p>' +
				           '</div>' +
				           '</div>';


				code.push( html );
			}
		} );
		tg.html( code.join( '' ) );
		tg.owlCarousel(
			{
				loop: true,
				margin: 16,
				responsiveClass: true,
				nav: false,
				dots: false,
				autoplay: true,
				responsive: {
					0: { items: 1 },
					600: { items: 1 },
					1000: { items: 1 }
				}
			}
		);
	};

	window.makeFacebookEvents = ( res ) => {
		const d = res.data;
		const tg = $( '#facebook-event-feed .feed' );
		const code = [];

		$.each( d, function () {

			const html = '<div class="col-4">' +
			             '<div class="card event">' +
			             '<img src="' + this.cover.source + '" class="card-img-top" alt="">' +
			             '<h5 class="card-header text-center">' + this.name + '</h5>' +
			             '<div class="card-body">' +
			             '<p class="card-text">' + this.description + '</p>' +
			             '<ul class="list-unstyled">' +
			             '<li><b>시작</b> : ' + showDateKr( this.start_time ) + '</li>' +
			             '<li><b>종료</b> : ' + showDateKr( this.end_time ) + '</li>' +
			             '<li><b>장소</b> : ' + this.place.name + '</li>' +
			             '</ul>' +
			             '</div>' +
			             '</div>' +
			             '</div>';

			code.push( html );
		} );

		tg.html( code.join( '' ) );
	};

	$( '.banner-carousel' ).owlCarousel( {
		                                     loop: true,
		                                     margin: 10,
		                                     responsiveClass: true,
		                                     nav: false,
		                                     dots: false,
		                                     autoplay: true,
		                                     autoplayTimeout: 5000,
		                                     responsive: {
			                                     0: {
				                                     items: 2,
			                                     },
			                                     600: {
				                                     items: 3,
			                                     },
			                                     1000: {
				                                     items: 5,
			                                     }
		                                     }
	                                     } );

	window.showResult = ( tag, status ) => {
		let tg = $( '#series-contents-current .row' );

		if ( status === 0 ) {
			tg = $( '#series-contents-old' );
		}

		tg.html( tag );
	};

	window.loadSeriesSermons = ( page, status ) => {
		const current_url = location.origin + location.pathname;

		axios.get( '/api/get/series?page=' + page + '&ongoing=' + status )
		     .then( function ( res ) {
			     const d = res.data;
			     const { total, per_page, current_page, last_page, first_page_url, last_page_url, next_page_url, prev_page_url, data } = d.series;

			     let tpl = '';

			     if ( status === 0 ) {
				     // 종료된 설교 시리즈
				     tpl = '<div class="row">' +
				           '<div class="col-4 col-md-2"><div class="img-wrap my-2"></div></div>' +
				           '<div class="col">' +
				           '<div class="d-flex flex-column justify-content-center my-2">' +
				           '<h4 class="series-title my-1" style="font-size:1rem;"></h4>' +
				           '<p class="excerpt"></p>' +
				           '<a href="" class="detail_link">Detail</a>' +
				           '<div><small class="updated_at"></small></div>' +
				           '</div>' +
				           '</div>' +
				           '</div>';
			     }
			     else {
				     // 진행 중 설교 시리즈
				     tpl = '<div class="col-sm-3">' +
				           '<div class="card border-0 rounded-0 mb-4">' +
				           '<div class="card-body">' +
				           '<div class="img-wrap position-relative border-1"></div>' +
				           '<h4 class="series-title text-center my-3" style="font-size:1rem;"></h4>' +
				           '<p class="excerpt"></p>' +
				           '<p class="text-danger"><i class="fa fa-circle text-success"></i> ' +
				           '<a href="">Detail</a>' +
				           '<div><small class="updated_at"></small></div>' +
				           '</p>' +
				           '</div>' +
				           '</div>' +
				           '</div>';
			     }

			     let code = [];

			     $.each( data, function () {
				     const epi = $( tpl ).clone();

				     if ( status === 0 ) {
					     epi.find( '.img-wrap' ).html( '<a href="' + current_url + '?cid=' + this.id + '"><img src="' + this.thumbnail_url + '" class="border img-fluid"></a>' );
					     epi.find( '.detail_link' ).attr( 'href', current_url + '?cid=' + this.id );
					     epi.find( '.series-title' ).text( this.title );
					     epi.find( '.excerpt' ).text( this.content );
					     epi.find( '.updated_at' ).text( 'updated at ' + this.updated_at );
					     code.push( '<div class="row">' + epi.html() + '</div>' );

				     }
				     else {
					     epi.find( '.card' ).attr( 'onclick', 'location.href="' + current_url + '?cid=' + this.id + '"' );
					     epi.find( '.img-wrap' )
					        .attr( 'style', 'height:220px;background-image:url(' + this.thumbnail_url + ');background-position:center;background-size:cover;' );
					     epi.find( '.series-title' ).text( this.title );
					     epi.find( '.excerpt' ).text( this.content );
					     epi.find( '.updated_at' ).text( 'updated at ' + this.updated_at );
					     epi.find( 'a' ).attr( 'href', current_url + '?cid=' + this.id );
					     code.push( '<div class="col-sm-6">' + epi.html() + '</div>' );

				     }

			     } );

			     showResult( code.join( '' ), status );

			     if ( status === 0 && total > per_page ) {
				     const pagination = [
					     '<li class="page-item"><a class="page-link" href="' + first_page_url + '&ongoing=0">처음</a></li>',
					     '<li class="page-item"><a class="page-link" href="' + prev_page_url + '&ongoing=0">이전</a></li>'
				     ];

				     for ( let i = 1; i <= last_page; ++i ) {
					     const active = current_page === i ? 'active' : '';
					     const pcode = '<li class="page-item' + active + '">' +
					                   '<a class="page-link" href="{{ url()->current() }}?page=' + i + '&ongoing=0">' + i + '</a>' +
					                   '</li>';
					     pagination.push( pcode );
				     }
				     pagination.push( '<li class="page-item"><a class="page-link" href="' + next_page_url + '&ongoing=0">다음</a></li>' +
				                      '<li class="page-item"><a class="page-link" href="' + last_page_url + '&ongoing=0">마지막</a></li>' );

				     $( '#series-pagination .pagination' ).html( pagination.join( "\n\r" ) );
				     $( '#series-pagination' ).show();
			     }

		     } );
	};

	window.getEpisodes = ( cid ) => {
		return axios.get( '/api/get/series/' + cid + '/episodes' );
	};

	// 기쁨의언덕 신청폼
	$( 'form#pleasant-hill-application' ).submit( function ( e ) {
		e.preventDefault();
		const name = $( this ).find( '#name' ).val();
		const phone = $( this ).find( '#phone' ).val();
		const self = $( this );

		if ( name.length === 0 ) {
			$( this ).find( '#name' ).addClass( 'is-invalid' ).focus();
			$( this ).find( '#name' ).next( '.invalid-feedback' ).text( '신청하시는 분의 이름을 입력하세요.' ).show();
			return false;
		}

		if ( phone.length === 0 ) {
			$( this ).find( '#phone' ).addClass( 'is-invalid' ).focus();
			$( this ).find( '#phone' ).next( '.invalid-feedback' ).text( '연락 받으실 전화번호를 입력하세요.' ).show();
			return false;
		}

		axios.post( '/api/send/mail/pleasant-hill-application', { "name": name, "phone": phone } )
		     .then( function ( res ) {
			     self.find( '#success-info' ).show();
			     setTimeout( function () {
				     self.find( 'input' ).removeClass( 'is-invalid' ).val( '' );
				     self.find( 'input' ).next( '.invalid-feedback' ).empty().hide();
				     self.find( '#success-info' ).fadeOut();
			     }, 2000 );
		     } )
		     .catch( function ( err ) {
			     alert( '신청서를 접수하지 못했습니다. 관리자에게 문의바랍니다.' );
			     console.log( err.response !== undefined ? err.response : err );
		     } )

	} );

	// 세례식 신청
	$( 'form#baptize-request-form' ).submit( function ( e ) {
		e.preventDefault();
		const name = $( this ).find( '#name' ).val();
		const phone = $( this ).find( '#phone' ).val();
		const email = $( this ).find( '#email' ).val();
		const self = $( this );

		if ( name.length === 0 ) {
			$( this ).find( '#name' ).addClass( 'is-invalid' ).focus();
			$( this ).find( '#name' ).next( '.invalid-feedback' ).text( '신청하시는 분의 이름을 입력하세요.' ).show();
			return false;
		}

		if ( phone.length === 0 ) {
			$( this ).find( '#phone' ).addClass( 'is-invalid' ).focus();
			$( this ).find( '#phone' ).next( '.invalid-feedback' ).text( '연락 받으실 전화번호를 입력하세요.' ).show();
			return false;
		}

		if ( email.length === 0 ) {
			$( this ).find( '#email' ).addClass( 'is-invalid' ).focus();
			$( this ).find( '#email' ).next( '.invalid-feedback' ).text( '연락 받으실 이메일 주소를 입력하세요.' ).show();
			return false;
		}

		axios.post( '/api/send/mail/batize-request', { "name": name, "phone": phone, "email": email } )
		     .then( function ( res ) {
			     self.find( '#success-info' ).show();
			     setTimeout( function () {
				     self.find( 'input' ).removeClass( 'is-invalid' ).val( '' );
				     self.find( 'input' ).next( '.invalid-feedback' ).empty().hide();
				     self.find( '#success-info' ).fadeOut();
			     }, 2000 );
		     } )
		     .catch( function ( err ) {
			     alert( '신청서를 접수하지 못했습니다. 관리자에게 문의바랍니다.' );
			     console.log( err.response !== undefined ? err.response : err );
		     } )

	} );

	// 모달 초기화 함수
	window.initFacebookModal = {
		// 모달의 모든 내용을 초기화
		clear: function ( modal ) {
			if ( !modal ) return;

			this.clearText( modal );
			this.clearImage( modal );
			this.clearLinks( modal );
			this.clearSocial( modal );
		},

		// 텍스트 콘텐츠 초기화
		clearText: function ( modal ) {
			const textElements = [
				'p',
				'.date',
				'.video',
				'.album',
				'.comments'
			];

			textElements.forEach( selector => {
				const element = modal.querySelector( selector );
				if ( element ) element.textContent = '';
			} );
		},

		// 이미지 관련 요소 초기화
		clearImage: function ( modal ) {
			const featuredImage = modal.querySelector( '.featured-image' );
			if ( featuredImage ) {
				featuredImage.style.display = '';

				const imgLink = featuredImage.querySelector( 'a' );
				if ( imgLink ) {
					imgLink.href = '';
					imgLink.dataset.lightbox = '';

					const img = imgLink.querySelector( 'img' );
					if ( img ) {
						img.src = '';
						img.style.display = 'none';
					}
				}
			}
		},

		// 링크 초기화
		clearLinks: function ( modal ) {
			// 일반 링크
			const link = modal.querySelector( '.modal-footer .link' );
			if ( link ) {
				link.href = '';
				link.textContent = '';
				link.style.display = 'none';
			}

			// 퍼머링크
			const permalink = modal.querySelector( '.modal-footer .permalink' );
			if ( permalink ) {
				permalink.href = '';
			}
		},

		// 소셜 관련 요소 초기화
		clearSocial: function ( modal ) {
			const fbLike = modal.querySelector( '.fb-like' );
			if ( fbLike ) {
				fbLike.dataset.href = '';
			}
		}
	};

	window.getFBPost = function ( obj ) {
		const id = obj.dataset.fbPostId;
		const modal = document.querySelector( '#FBSinglePostModal' );

		if ( !modal ) {
			console.error( 'Modal element not found' );
			return;
		}

		// 스피너 설정
		let spinner = modal.querySelector( '.fb-loading-spinner' );
		if ( !spinner ) {
			spinner = document.createElement( 'div' );
			spinner.className = 'fb-loading-spinner d-none justify-content-center align-items-center position-absolute w-100 h-100';
			spinner.style.cssText = 'background: rgba(255,255,255,0.8); top: 0; left: 0; z-index: 1050;';
			spinner.innerHTML = '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>';
			modal.querySelector( '.modal-content' ).appendChild( spinner );
		}

		// 모달 초기화 및 표시
		window.initFacebookModal.clear( modal );
		$( modal ).modal( 'show' );
		spinner.classList.replace( 'd-none', 'd-flex' );

		axios.get( '/api/facebook-feed/post/' + id )
		     .then( function ( r ) {
			     if ( r.data.status === 200 ) {
				     const { item } = r.data;

				     // item이 null인 경우 처리
				     if ( !item ) {
					     throw new Error( '게시물을 찾을 수 없습니다.' );
				     }

				     if ( item.message && item.message.length > 0 ) {
					     modal.querySelector( '.modal-body p' ).innerHTML = item.message.replace( /\n/gi, '<br>' );
				     }

				     if ( item.full_picture ) {
					     const imgLink = modal.querySelector( '.featured-image > a' );
					     imgLink.href = item.full_picture;
					     imgLink.dataset.lightbox = item.id;

					     const picture = modal.querySelector( '.modal-body .featured-image > a > img' );
					     picture.src = item.full_picture;
					     picture.style.display = '';
				     }

				     if ( item.attachments ) {
					     Array.from( item.attachments ).forEach( attached => {
						     switch ( attached.media_type ) {
							     case "video":
								     const videoTpl = document.getElementById( 'fb-video-tpl' ).content.cloneNode( true );
								     videoTpl.querySelector( '.fb-video' ).dataset.href = attached.unshimmed_url;
								     videoTpl.querySelector( '.video-title' ).textContent = attached.title;
								     modal.querySelector( '.video' ).appendChild( videoTpl );
								     modal.querySelector( '.featured-image' ).style.display = 'none';
								     FB.XFBML.parse( modal.querySelector( '.video' ) );
								     break;

							     case "album":
								     const album = document.createElement( 'div' );
								     album.classList.add( 'card-columns' );

								     attached.subattachments.map( obj => {
									     const col = document.createElement( 'div' );
									     col.classList.add( 'card', 'mb-3', 'rounded' );

									     const imgObj = obj.media.image;
									     const img = document.createElement( 'img' );
									     img.src = imgObj.src;
									     img.classList.add( 'w-100', 'd-block', 'card-img-top' );

									     const link = document.createElement( 'a' );
									     link.href = imgObj.src;
									     link.dataset.lightbox = item.id;
									     link.appendChild( img );
									     col.appendChild( link );
									     album.appendChild( col );
								     } );
								     modal.querySelector( '.album' ).appendChild( album );
								     break;
						     }
					     } );
				     }

				     if ( item.link ) {
					     const link = modal.querySelector( '.modal-footer .link' );
					     link.style.display = '';
					     link.href = item.link;
					     link.textContent = '첨부된 링크 보기';

					     if ( item.link.match( /https\:\/\/ckumc\.org/gi ) ) {
						     link.target = '_self';
						     link.textContent = '자세히 보기';
					     }
				     }

				     const fbLike = modal.querySelector( '.fb-like' );
				     fbLike.dataset.href = item.permalink_url;
				     FB.XFBML.parse( modal.querySelector( '.fb-like' ) );

				     if ( item.created_time ) {
					     const date = item.created_time.date || item.created_time;
					     modal.querySelector( '.modal-body .date' ).textContent =
						     Moment( date ).tz( 'America/Chicago' ).format( 'DD MMMM YYYY' );
				     }

				     modal.querySelector( '.modal-footer .permalink' ).href = item.permalink_url;
			     }
			     else {
				     throw new Error( r.data.message );
			     }
		     } )
		     .catch( function ( err ) {
			     // 오류 발생 시 스피너 숨기고
			     spinner.classList.replace( 'd-flex', 'd-none' );

			     console.log( 'Original error:', err.response ?? err );

			     let errorMessage = '통신 오류: 잠시 후 다시 시도해보세요.';

			     try {
				     let responseData = err.response?.data;
				     if ( responseData?.message ) {
					     // Check if the message contains a nested Facebook error
					     if ( responseData.message.includes( 'Failed to fetch post:' ) ) {
						     const fbErrorJson = responseData.message.split( 'Failed to fetch post:' )[ 1 ].trim();
						     const fbError = JSON.parse( fbErrorJson );

						     // Facebook 에러 코드별 메시지
						     const errorMessages = {
							     1: '일시적인 서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
							     2: '일시적인 오류가 발생했습니다.',
							     4: '요청 횟수가 제한을 초과했습니다. 잠시 후 다시 시도해주세요.',
							     17: '사용자가 너무 많은 요청을 보냈습니다. 잠시 후 다시 시도해주세요.',
							     10: '권한이 부족합니다.',
							     190: '인증이 만료되었습니다. 페이지를 새로고침해주세요.',
							     100: '요청한 게시물을 찾을 수 없습니다.',
							     803: '이미 삭제된 게시물입니다.'
						     };

						     errorMessage = errorMessages[ fbError.error.code ] ||
						                    `Facebook 오류: ${fbError.error.message}`;
					     }
					     else {
						     errorMessage = responseData.message;
					     }
				     }
			     }
			     catch ( parseErr ) {
				     console.error( 'Error parsing error message:', parseErr );
			     }

			     alert( errorMessage );
			     $( modal ).modal( 'hide' );
		     } )
		     .finally( function () {
			     // 성공적인 경우에만 스피너 숨기기
			     if ( !modal.classList.contains( 'hide' ) ) {
				     spinner.classList.replace( 'd-flex', 'd-none' );
			     }
		     } );
	};

	window.listenSermon = ( permalink ) => {
		const tg = $( '#showPodcast' );
		tg.modal( 'show' );
		const endpoint = '/api/get-embed-code';
		axios.get( endpoint, { params: { permalink: permalink } } )
		     .then( function ( response ) {
			     tg.find( '.modal-body' ).html( response.data );
		     } )
	};

	window.loadMorePosts = function ( obj ) {

		let ep = obj.dataset.nextPosts;

		obj.setAttribute( 'disabled', true );
		obj.innerHTML = `
<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
  Loading...
			`;

		axios.post( '/api/facebook-feed/posts', { after: ep, limit: 20 } )
		     .then( ( r ) => {

			     if ( r.data.status === 200 ) {

				     r.data.posts.forEach( ( el ) => {
					     if ( el.length !== 0 ) {
						     makeFBData( el );
					     }
				     } );

				     feather.replace();

				     let more = document.getElementById( 'more-posts' );

				     if ( r.data.next ) {
					     more.dataset.nextPosts = r.data.next;
					     more.disabled = false;
					     more.textContent = 'More Posts';
				     }
				     else {
					     more.remove();
				     }

			     }
			     else {
				     console.error( r.data );
				     alert( r.data.message );
			     }

		     } )
		     .catch( ( err ) => {
			     console.error( err );
			     alert( '통신 오류' );
		     } )
	};

	window.makeFBData = function ( obj ) {

		const tg = document.getElementById( 'facebook-feed' );
		if ( obj.length !== 0 ) {
			const tplSrc = document.getElementById( 'facebook_post' );
			const tpl = document.importNode( tplSrc, true );
			const item = tpl.content;

			if ( obj.full_picture ) {
				const imgLink = item.querySelector( 'a' );
				imgLink.dataset.fbPostId = obj.id;
				item.querySelector( 'img' ).src = obj.full_picture;
			}

			const postIcon = item.querySelector( '.post-icon' );

			switch ( obj.type ) {
				case "video" :
					postIcon.dataset.feather = 'video';
					break;
				case "link" :
					postIcon.dataset.feather = 'link';
					break;
				case "photo" :
					postIcon.dataset.feather = 'image';
					break;
				default :
					postIcon.dataset.feather = 'pen-tool';
			}

			item.querySelector( 'small' ).textContent = Moment( obj.created_time ).tz( 'America/Chicago' ).format( 'DD MMMM YYYY' );

			const fbLinks = item.querySelectorAll( 'a.fb_post_link' );
			fbLinks.forEach( el => {
				el.dataset.fbPostId = obj.id;
			} );

			if ( obj.message && obj.message.length > 0 ) {
				// 문자열의 실제 길이를 계산하는 함수 (한글 2byte, 영문/숫자 1byte 기준)
				const getByteLength = ( str ) => {
					return str
						.split( '' )
						.map( s => s.charCodeAt( 0 ) > 127 ? 2 : 1 )
						.reduce( ( a, b ) => a + b, 0 );
				};

// 주어진 바이트 길이에 맞게 문자열 자르기
				const truncateByByte = ( str, maxByte ) => {
					let byteLength = 0;
					let targetLength = 0;

					for ( let i = 0; i < str.length; i++ ) {
						byteLength += str.charCodeAt( i ) > 127 ? 2 : 1;
						if ( byteLength > maxByte ) break;
						targetLength = i + 1;
					}

					return str.length > targetLength ? str.substring( 0, targetLength ) + '...' : str;
				};

// 실제 적용
				item.querySelector( '.card-text' ).textContent = obj.message
					? truncateByByte( obj.message, 200 )
					: '';
			}
			if ( undefined === obj.message && obj.name ) {
				item.querySelector( '.card-text' ).textContent = obj.name;
			}

			if ( undefined === obj.comments ) {
				item.querySelector( 'span' ).remove();
			}
			tg.appendChild( item );
		}
	};


})( jQuery );
